var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictoDimention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2610_63",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 29,
    width: 60,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3018 29.5732H80.3018V88.568H21.3018V29.5732Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2610_63)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2610_63",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 29,
    width: 59,
    height: 60
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3018 29.5732H72.833C74.6924 29.5732 76.4684 30.3128 77.7809 31.6253C79.0934 32.9378 79.833 34.7139 79.833 36.5732V81.6097C79.833 83.4691 79.0934 85.2451 77.7809 86.5576C76.4684 87.8701 74.6924 88.6097 72.833 88.6097H28.3018C26.4424 88.6097 24.6663 87.8701 23.3538 86.5576C22.0413 85.2451 21.3018 83.4691 21.3018 81.6097V36.5732C21.3018 34.7139 22.0413 32.9378 23.3538 31.6253C24.6663 30.3128 26.4424 29.5732 28.3018 29.5732Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2610_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3018 29.5732H72.833C74.6924 29.5732 76.4684 30.3128 77.7809 31.6253C79.0934 32.9378 79.833 34.7139 79.833 36.5732V81.6097C79.833 83.4691 79.0934 85.2451 77.7809 86.5576C76.4684 87.8701 74.6924 88.6097 72.833 88.6097H28.3018C26.4424 88.6097 24.6663 87.8701 23.3538 86.5576C22.0413 85.2451 21.3018 83.4691 21.3018 81.6097V36.5732C21.3018 34.7139 22.0413 32.9378 23.3538 31.6253C24.6663 30.3128 26.4424 29.5732 28.3018 29.5732Z",
    stroke: "black",
    strokeWidth: 4
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2610_63",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 48,
    width: 37,
    height: 41
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3018 48.3701H57.3018V88.3701H21.3018V48.3701Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2610_63)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2610_63",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 48,
    width: 37,
    height: 41
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2965 48.3701H50.6299C52.4893 48.3701 54.2705 49.1045 55.5778 50.417C56.8903 51.7295 57.6299 53.5107 57.6299 55.3649V81.6045C57.6299 83.4587 56.8903 85.2399 55.5778 86.5524C54.2705 87.8649 52.4893 88.5993 50.6299 88.5993H28.2965C26.4424 88.5993 24.6611 87.8649 23.3486 86.5524C22.0361 85.2399 21.3018 83.4587 21.3018 81.6045V55.3649C21.3018 53.5107 22.0361 51.7295 23.3486 50.417C24.6611 49.1045 26.4424 48.3701 28.2965 48.3701Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2610_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2966 48.3701H50.6299C52.4893 48.3701 54.2705 49.1045 55.5778 50.417C56.8903 51.7295 57.6299 53.5107 57.6299 55.3649V81.6045C57.6299 83.4587 56.8903 85.2399 55.5778 86.5524C54.2705 87.8649 52.4893 88.5993 50.6299 88.5993H28.2966C26.4424 88.5993 24.6611 87.8649 23.3486 86.5524C22.0361 85.2399 21.3018 83.4587 21.3018 81.6045V55.3649C21.3018 53.5107 22.0361 51.7295 23.3486 50.417C24.6611 49.1045 26.4424 48.3701 28.2966 48.3701Z",
    stroke: "black",
    strokeWidth: 4
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9115 87.6147H21.2969",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2969 18V88.6198",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.5H26.6042",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4111 91.9117V83.3076",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoDimention);
export default __webpack_public_path__ + "static/media/pictoDimention.d934d578557f8ca16bc176775876515d.svg";
export { ForwardRef as ReactComponent };